import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { TextInput, Button } from "flowbite-react";
import { useGetData } from "../../../../../hooks/useGetData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechasOeInterface } from "../../../../../interfaces/FechasOeInterface";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import HeaderPrint from "../../../../../components/HeaderFormsPrint/HeaderFormsPrint";
import fotoMapa from "../../../../../img/fotoMapa.png";
import FooterAutorizacionVD from "../../../../../img/Footer_AutorizacionVD.png";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const AutorizacionOEListaScreen = () => {
  const {isDarkMode} = useContext(ThemeContext);
  const tituloFormulario = "AUTORIZACIÓN AL PROCESO DE OTRAS EVALUACIONES";

  const [formData, setFormData] = useState({
    day: "",
    month: "",
    year: "",
  });

  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const { control, handleSubmit, setValue, reset } = useForm();

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFechaOE = useGetData<FechasOeInterface[]>({
    url: `/fechas_oe/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fechas_oe"],
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const navigate = useNavigate();

  const handlePrint = () => {
    const printContent = document.getElementById("printableContent");

    if (printContent) {
      const printWindow = window.open("", "", "width=800,height=600");

      if (printWindow) {
        printWindow.document.write(`
          <html>
            <head>
              <title>Vista Previa de Impresión</title>
              <style>
                @media print {
                  body {
                    margin: 20px;
                    font-family: Arial, sans-serif;
                  }
                }
              </style>
            </head>
            <body>${printContent.innerHTML}</body>
          </html>
        `);

        const styles = document.styleSheets;
        for (let i = 0; i < styles.length; i++) {
          try {
            if (styles[i].cssRules) {
              const styleTag = printWindow.document.createElement("style");
              for (let j = 0; j < styles[i].cssRules.length; j++) {
                styleTag.appendChild(
                  printWindow.document.createTextNode(
                    styles[i].cssRules[j].cssText
                  )
                );
              }
              printWindow.document.head.appendChild(styleTag);
            }
          } catch (e) {
            console.warn("No se pudo copiar una hoja de estilo:", e);
          }
        }

        printWindow.document.close();
        printWindow.onload = () => {
          setTimeout(() => {
            printWindow.print();
            printWindow.close();
          }, 500);
        };
      } else {
        alert("No se pudo abrir la ventana de impresión.");
      }
    }
  };

  useEffect(() => {
    if (queryFechaOE.data && queryFechaOE.data.length > 0) {
      const fechaoe = queryFechaOE.data[0];
      reset({
        autorizacion_oe: fechaoe.autorizacion_oe || "",
      });
    }
  }, [queryFechaOE.data, reset]);

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className="container mx-auto p-4">
        <form className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
          {/* Header */}
          <Header titulo={tituloFormulario} />

          {/* Contenido del formulario */}
          <div className="p-6">
            <div className="text-center mb-8">
              <div className="flex justify-left items-center gap-2 mb-4">
                <p className={`mt-3 ${isDarkMode ? "text-gray-300" : "text-black"}`}>Ciudad de México a</p>
                <Controller
                  name="autorizacion_oe"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      id="autorizacion_oe"
                      type="date"
                      value={
                        field.value ||
                        (queryFechaOE.data && queryFechaOE.data.length > 0
                          ? queryFechaOE.data[0]?.autorizacion_oe || ""
                          : "")
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className={`text-left w-auto border rounded ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                    />
                  )}
                />
              </div>
              <h2 className={`text-xl font-bold mb-4 flex items-center ${isDarkMode ? "text-white" : ""}`}>
                AUTORIZACIÓN AL PROCESO DE EVALUACIONES DE OTRAS EVALUACIONES
              </h2>
            </div>

            <div className="space-y-6">
              <div className="flex items-start">
                <span className={`mr-2 ${isDarkMode ? "text-gray-200" : ""}`}>Yo</span>
                <TextInput
                  type="text"
                  name="name"
                  value={`${queryEvaluado.data?.nombre || ""} ${
                    queryEvaluado.data?.apellido_paterno || ""
                  } ${queryEvaluado.data?.apellido_materno || ""}`}
                  onChange={handleInputChange}
                  className={`flex-1 mx-2 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                  disabled
                />
                <span className={`ml-2 ${isDarkMode ? "text-gray-200" : ""}`}>
                  , autorizo que me aplique todas las Otras Evaluaciones
                </span>
              </div>

              <p className={`text-justify ${isDarkMode ? "text-gray-200" : ""}`}>
                así como todas las necesarias para el proceso de evaluación, etc.
                Asimismo, autorizo a la empresa SKA TRACKING AND SECURITY S.A. de
                C.V. para que proporcione toda la información y documentación que
                derive de las evaluaciones de pruebas de confianza que me realicen.
              </p>

              <p className={`text-justify ${isDarkMode ? "text-gray-200" : ""}`}>
                En este acto autorizo y conozco el aviso de privacidad el cual se
                encuentra publicado en
                https://skyangel.com.mx/avisodeprivacidad.htlm, por lo cual en este
                acto consiento que SKA TRACKING AND SECURITY S.A. de C.V. podrá
                recabar mis datos personales de conformidad con los términos
                establecidos en dicho aviso.
              </p>

              <p className={`text-justify ${isDarkMode ? "text-gray-200" : ""}`}>
                Bajo protesta de decir verdad hago constar que los datos
                proporcionados en el proceso de evaluación son verdaderos.
              </p>

              <div className="mt-12 text-center">
                <p className={`mb-8 font-bold ${isDarkMode ? "text-white" : ""}`}>ATENTAMENTE</p>
                <div className={`w-64 mx-auto pt-2 ${isDarkMode ? "border-t border-white" : "border-t border-black"}`}>
                  <p className={`text-sm ${isDarkMode ? "text-gray-300" : ""}`}>NOMBRE Y FIRMA</p>
                </div>
              </div>
            </div>
          </div>

          {/* Botones */}
          <div className="mt-4 mb-4 px-4">
            <div className="flex justify-between">
              <Button
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(-1);
                }}
                className={`ml-2 ${isDarkMode ? "bg-red-600 hover:bg-red-800 text-white" : "bg-red-500 text-white"}`}
              >
                Regresar
              </Button>
              <Button 
                onClick={handlePrint}
                className={`ml-2 ${isDarkMode ? "bg-blue-600 hover:bg-blue-800 text-white" : "bg-blue-500 text-white"}`}
              >
                Imprimir
              </Button>
            </div>
          </div>

          {/* Footer */}
          <div className={`h-12 mt-8 flex items-center justify-center ${isDarkMode ? "bg-blue-900" : "bg-customBlue"}`}>
            <p className="text-sm text-white px-4">
              <span className="font-bold">DOCUMENTO CONFIDENCIAL</span>, prohibido
              su reproducción, copia o sacar este documento de las Instalaciones de
              Skyangel
            </p>
          </div>

          {/* Imprimir */}
          <div id="printableContent" style={{ display: "none" }}>
            <div className="max-w-4xl mx-auto bg-white rounded-lg overflow-hidden mt-4 relative">
              {/* Header */}
              <HeaderPrint titulo={tituloFormulario} />
              {/* Título del formulario */}
              <div
                id="headerContent"
                className="text-center transform transition-all duration-1000 ease-out"
              >
                <h1
                  className="text-black text-xl font-bold py-3 px-8 rounded-b-md inline-block shadow-lg flex justify-center transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
                  style={{
                    backgroundImage: `url(${fotoMapa})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  {tituloFormulario}
                </h1>
              </div>

              {/* Contenido del formulario */}
              <div className="p-2">
                <div className="text-center mb-2">
                  <div className="flex justify-left items-center gap-2 mb-4">
                    <p className="mt-3">Ciudad de México a</p>
                    <Controller
                      name="autorizacion_oe"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <input
                          id="autorizacion_oe"
                          type="date"
                          value={
                            field.value ||
                            (queryFechaOE.data && queryFechaOE.data.length > 0
                              ? queryFechaOE.data[0]?.autorizacion_oe || ""
                              : "")
                          }
                          disabled={true}
                          onChange={(e) => field.onChange(e.target.value)}
                          className="text-left w-auto border rounded"
                        />
                      )}
                    />
                  </div>
                  <h2 className="text-lg font-bold mb-4 flex items-center">
                    AUTORIZACIÓN AL PROCESO DE EVALUACIONES DE OTRAS EVALUACIONES
                  </h2>
                </div>

                <div className="space-y-6">
                  <div className="flex items-start">
                    <span className="mr-2">Yo</span>
                    <TextInput
                      type="text"
                      name="name"
                      value={`${queryEvaluado.data?.nombre || ""} ${
                        queryEvaluado.data?.apellido_paterno || ""
                      } ${queryEvaluado.data?.apellido_materno || ""}`}
                      onChange={handleInputChange}
                      className="flex-1 mx-2"
                    />
                    <span className="ml-2">
                      , autorizo que me aplique todas las Otras Evaluaciones
                    </span>
                  </div>

                  <p className="text-justify">
                    así como todas las necesarias para el proceso de evaluación,
                    etc. Asimismo, autorizo a la empresa SKA TRACKING AND SECURITY
                    S.A. de C.V. para que proporcione toda la información y
                    documentación que derive de las evaluaciones de pruebas de
                    confianza que me realicen.
                  </p>

                  <p className="text-justify">
                    En este acto autorizo y conozco el aviso de privacidad el cual
                    se encuentra publicado en
                    https://skyangel.com.mx/avisodeprivacidad.htlm, por lo cual en
                    este acto consiento que SKA TRACKING AND SECURITY S.A. de C.V.
                    podrá recabar mis datos personales de conformidad con los
                    términos establecidos en dicho aviso.
                  </p>

                  <p className="text-justify">
                    Bajo protesta de decir verdad hago constar que los datos
                    proporcionados en el proceso de evaluación son verdaderos.
                  </p>

                  <br />
                  <br />
                  <br />
                  <br />
                  <br />

                  <div className="mt-12 text-center">
                    <p className="mb-8 font-bold">ATENTAMENTE</p>
                    <div className="w-64 mx-auto border-t border-black pt-2">
                      <p className="text-sm">NOMBRE Y FIRMA</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Footer */}
            <div className="bg-customBlue h-12 flex items-center justify-center">
              <img src={FooterAutorizacionVD} alt="FooterAutorizacionVD" />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
